import { render, staticRenderFns } from "./ReferralOperations.vue?vue&type=template&id=c0397296&scoped=true&"
import script from "./ReferralOperations.vue?vue&type=script&lang=js&"
export * from "./ReferralOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0397296",
  null
  
)

export default component.exports